<template>
  <div class="ADDCourse">
      <el-dialog
        width="60%"
          :visible.sync="ADDCoureseDialog">
        <el-form :model="courseForm" :rules="rules" ref="courseForm" class="demo-ruleForm">
          <el-form-item :label="$t('Education.languages10')" prop="courseName">
            <el-input v-model="courseForm.courseName" maxlength="25" show-word-limit></el-input>
          </el-form-item>

          <el-form-item :label="$t('Education.languages11')" prop="courseCover" >
            <div class="cover">
              <el-upload
                  :auto-upload="true"
                  class="avatar-uploader"
                  name="images"
                  :action="actionUrl"
                  :multiple="false"
                  :show-file-list="false"
                  v-loading="updataload"
                  :before-upload="handleupload"
                  :on-success="handleAvatarSuccess"
                  accept="image/jpeg,image/png,image/jpg"
                  list-type="picture-card"
              >
                <img v-if="courseForm.courseCover" :src="courseForm.courseCover" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p class="illustrate">{{$t('Education.languages13')}}</p>
            </div>
          </el-form-item>

          <el-form-item :label="$t('Education.languages12')" prop="courseDescription">
            <el-input type="textarea" v-model="courseForm.courseDescription" style="width:400px"  maxlength="200" show-word-limit></el-input>
          </el-form-item>

          <el-form-item label="标签" prop="courseTag">
            <el-input v-model="courseForm.courseTag"  maxlength="15" show-word-limit></el-input>
            <!-- <p>说明：标签可作为查询课程的条件，多个标签需用“，”分割</p> -->
          </el-form-item>

          <el-form-item label="课程试卷" v-if="isNew!=0">
            <el-select v-model="courseForm.examId" clearable @change="changeExam" placeholder="请选择">
              <el-option
                v-for="item in optionexamListData"
                :key="item.examId"
                :label="item.examTitle"
                :value="item.examId">
              </el-option>
            </el-select>
            <!-- <el-button type="primary" style="margin-left: 20px;" @click="ClickAddPaper(courseForm.courseId)">新增试卷</el-button> -->
          </el-form-item>

          <el-form-item class="examtable" v-if="isNew!=0">
            <el-table
                :data="examListData"
                :cell-style="{'text-align':'center'}"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
              <el-table-column prop="examTitle" label="试卷名称"></el-table-column>
              <el-table-column prop="examRadioNum" label="单选题"></el-table-column>
              <el-table-column prop="examMultipleNum" label="多选题"></el-table-column>
              <el-table-column prop="examQuestionNum" label="问答题"></el-table-column>
              <el-table-column prop="updateBy" label="最近操作者"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间"></el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <span v-if="scope.row" class="operateitem" @click="$router.push('addtestpaper?isNew=1&examType=2&examId='+scope.row.examId)">维护试卷</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('courseForm')">{{$t('Education.languages14')}}</el-button>
            <el-button @click="ADDCoureseDialog=false;">{{$t('Education.languages15')}}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>
<script>
export default{
    name:'ADDCourse',
    data() {
        return {
            rules:{
                courseName:[{required: true, message:"请输入课程名", trigger: 'blur'}],
                courseDescription:[{required: true, message:"请输入课程说明", trigger: 'blur'}],
                courseCover:[{required: true, message:"请上传封面图", trigger: 'change'}]
            },
            isNew:false,
            issubmitForm:true,
            actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
            ADDCoureseDialog:false,
            examListData:[],
            optionexamListData:[],
            updataload:false,
            courseForm:{
                courseName:'',
                courseCover:'',
                courseDescription:'',
                courseTag:'',
                examId:''
            },
            examParams:{
              examRelId:'',
              pageNum:1,
              pageSize:20,
              examType:2
            }
        }
    },
    watch:{
      ADDCoureseDialog(newval,oldval){
        if(!newval){
          this.$refs['courseForm'].resetFields();
        }
      }
    },
    methods: {
        ClickADDCourse(num,data){
            this.isNew=num==0?false:true;
            this.ADDCoureseDialog=true;
            this.courseForm=this.$options.data().courseForm;
            this.examParams.examRelId=num==0?'':data.courseId;
            if(num==1){//修改课程
              this.examListData=[];
              this.getexamlist();
              this.$Http_Get('edu/course/getInfo/'+data.courseId).then(res=>{
                if(res.Code==0){
                  this.courseForm['courseId']=res.Data.courseId;
                  this.courseForm.courseName=res.Data.courseName;
                  this.courseForm.courseDescription=res.Data.courseDescription;
                  this.courseForm.courseTag=res.Data.courseTag;
                  this.courseForm.courseCover=res.Data.courseCover;
                  this.courseForm.examId=res.Data.examId;
                  this.examListData.push(res.Data.exam);
                }else{
                  this.$message({type: 'error', message:"获取课程详情失败"});
                }
              })
            };
        },
        getexamlist(){
          this.$Http_Post('edu/exam/list',this.examParams).then(res=>{
            if(res.Code==0){
              this.optionexamListData=res.Data;
            }else{
              this.$message({type: 'error', message:"获取试卷列表失败"});
            }
          })
        },
        changeExam(val){
          this.examListData=[];
          for(let item of this.optionexamListData){
              if(item.examId==val){
                this.examListData.push(item);
              }
          }
        },
        handleupload(file){
          if (file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
            this.updataload=true;
          }else{
            this.$message({type: 'error', message:"请上传正确的图片格式"});
          }
        },
        ClickAddPaper(val){
          this.ADDCoureseDialog=false;
          this.$router.push('addtestpaper?isNew=0&examType=2&courseId='+val)
        },
        // 上传图片
        handleAvatarSuccess(res, fileList) {
            fileList['img']=res.Data;
            this.courseForm.courseCover=res.Data;
            this.updataload=false;
        },
        // 新增及修改
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid && this.issubmitForm) {
                  this.issubmitForm=false;
                this.changeExam(this.courseForm.examId);
                let Url=this.isNew?'/edu/course/edit':'edu/course/add';
                this.$Http_Post(Url,this.courseForm).then(res=>{
                  this.issubmitForm=true;
                    if(res.Code==0){
                    this.ADDCoureseDialog=false;
                    this.courseForm=this.$options.data().courseForm;
                    this.$parent.CourseList();
                    this.$message({
                        type: 'success',
                        message: res.Message,
                    })
                    }else{
                    this.$message({
                        type: 'error',
                        message: res.Message,
                    })
                    }
                })
                } else {
                  if(!this.issubmitForm){
                    this.$message({
                        type: 'error',
                        message:"请勿重复提交",
                    })
                  }
                console.log('error submit!!');
                return false;
                }
            });
        },
    },
    destroyed() {
      this.ADDCoureseDialog=false;
    },
}
</script>
<style>
.ADDCourse .avatar{width: 148px;height: 148px;display: block;}
.ADDCourse .avatar-uploader{display: inline-block;}
.ADDCourse .pagination{padding: 30px 0 0;}
.ADDCourse .illustrate{display: inline-flex;width: 220px;line-height: 30px;padding: 0 10px;}
.ADDCourse .el-form-item__label{width:100px;}
.ADDCourse .el-form-item__content{display: inline-block;}
.ADDCourse .examtable .el-form-item__content{display: block;}
.operateitem{padding: 0 5px 0 0;color:#0088ff;cursor: pointer}
</style>